import api from '@Services/api';

export const upsertAsset = async (key: string, value: string) =>
	await api.put('settings/assets', { key, value });

export const deleteAsset = async (key: string) =>
	await api.delete('settings/assets', { data: { key } });
